import { render } from "./profileMenu.vue?vue&type=template&id=3c73e52e&scoped=true"
import script from "./profileMenu.vue?vue&type=script&lang=js"
export * from "./profileMenu.vue?vue&type=script&lang=js"

import "./profileMenu.vue?vue&type=style&index=0&id=3c73e52e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c73e52e"]])

export default __exports__